import { render, staticRenderFns } from "./RolesView.vue?vue&type=template&id=5acf0439"
import script from "./RolesView.vue?vue&type=script&lang=js"
export * from "./RolesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports